/* tslint:disable */
/* eslint-disable */
/**
 * SR AAT specification
 * Description
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SearchGroup
 */
export interface SearchGroup {
    /**
     * 
     * @type {number}
     * @memberof SearchGroup
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof SearchGroup
     */
    name?: string;
    /**
     * 
     * @type {number}
     * @memberof SearchGroup
     */
    parentGroupId?: number;
}

/**
 * Check if a given object implements the SearchGroup interface.
 */
export function instanceOfSearchGroup(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SearchGroupFromJSON(json: any): SearchGroup {
    return SearchGroupFromJSONTyped(json, false);
}

export function SearchGroupFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchGroup {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'parentGroupId': !exists(json, 'parentGroupId') ? undefined : json['parentGroupId'],
    };
}

export function SearchGroupToJSON(value?: SearchGroup | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'parentGroupId': value.parentGroupId,
    };
}

